import { size } from 'lodash'
import React, { ReactElement, useEffect } from 'react'

import { FeedbackBadge } from '../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../1stlog-ui/src/components/Field/useFieldRaw'
import useFieldValue from '../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import { useProductSettings } from '../../../Products'

type MaxColisValidationProps = {}

export const MaxColisValidation = (
  props: MaxColisValidationProps,
): ReactElement => {
  const {} = props

  const { maxColis } = useProductSettings()

  const colis: unknown[] = useFieldValue('colis')

  const {
    meta,
    input: { onChange },
  } = useFieldRaw('isMaxColisInvalid', {
    validate: (value) => {
      if (value) {
        return i18n.t('max_x_colis_allowed', {
          defaultValue:
            'Für dieses Servicelevel sind maximal {{count}} Colis erlaubt.',
          count: maxColis,
        })
      }
    },
    subscribeAll: true,
  })

  useEffect(() => {
    onChange(maxColis && maxColis > 0 && size(colis) > maxColis)
  }, [colis, maxColis])

  return (
    <>
      <div className="mb-2">
        <FeedbackBadge meta={meta} />
      </div>
    </>
  )
}
